// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".merchantBtn___1J3Vt{margin-top:16px;font-size:16px}.rulesContainer___eaY4C{margin:0 16px}\n", "",{"version":3,"sources":["webpack://./src/routes/Revisions/routes/RevisionWindow/components/SingleMerchantView/index.css"],"names":[],"mappings":"AAAA,qBACI,eAAA,CACA,cAAA,CAGJ,wBALA,aAAA","sourcesContent":[".merchantBtn {\n    margin-top: 16px;\n    font-size: 16px;\n}\n\n.rulesContainer {\n    margin: 0 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"merchantBtn": "merchantBtn___1J3Vt",
	"rulesContainer": "rulesContainer___eaY4C"
};
export default ___CSS_LOADER_EXPORT___;
